import React, { useEffect, useRef } from "react";
import "./ProviderOverviewSection.scss";
import { useState } from "react";
import PopupModal from "../../../common/PopupModal";
import AutoComplete from "../../../common/AutoComplete";
import "./providerLanguagesSection.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAddProviderLanguages,
  fetchDeleteProviderLanguages,
  fetchLanguageSuggestions,
  fetchProviderLanguages,
} from "../../../store/ProviderInfo/ProviderLanguageActions";
import { useLocation } from "react-router-dom";

const ProviderLanguagesSection = () => {
  const [openPopup, setOpenPopup] = useState(false);
  const [confirmDeleteMap, setConfirmDeleteMap] = useState({});
  const [hasSearched, setHasSearched] = useState(false);

  const dispatch = useDispatch();
  const { langData, langError, lngErrorMsg } = useSelector(
    (state) => state.induvidualProviderLang
  );

  const { langSuggestionErrorMsg, suggestionError, suggestionData } =
    useSelector((state) => state.langSuggestion);

  const location = useLocation();
  const locationData = location.pathname.split("/");
  const providerId = locationData[2];

  useEffect(() => {
    dispatch(fetchProviderLanguages(providerId));
  }, []);

  const addedLanguagesRef = useRef([]);

  const toggleConfirmDelete = (displayId, value) => {
    setConfirmDeleteMap((prev) => ({
      ...prev,
      [displayId]: value,
    }));
  };

  const deleteAPiCall = (displayId) => {
    dispatch(
      fetchDeleteProviderLanguages({ providerId, languageId: displayId })
    ).then(() => {
      dispatch(fetchProviderLanguages(providerId));
      setConfirmDeleteMap((prev) => ({
        ...prev,
        [displayId]: false,
      }));
    });
  };

  // Render functions
  const RenderLanguagesAutoComplete = () => {
    return (
      <div>
        <AutoComplete
          label=""
          APIError={suggestionError ? langSuggestionErrorMsg : ""}
          suggestions={suggestionData && suggestionData}
          deleteItem={() => {}}
          renderAddedValues
          autoCompletePlaceHolders="Enter language"
          onValueSelect={(name, values) => {
            addedLanguagesRef.current = values;
          }}
          onValueChangeCallback={(res) => {
            dispatch(fetchLanguageSuggestions(res));
            setHasSearched(true);
          }}
          name="Languages"
          defaultValue={langData}
        />
      </div>
    );
  };

  const RenderAddLanguagesPopup = () => {
    return (
      <PopupModal
        isOpen={openPopup}
        onClose={() => {
          setOpenPopup(!openPopup);
          setHasSearched(false);
        }}
        enableSave
        disableSave={!hasSearched}
        onSave={() => {
          if (!hasSearched) return;
          const updatedLanguagesData = addedLanguagesRef.current?.map(
            (item) => item.name
          );
          const data = {
            languages: updatedLanguagesData,
          };
          dispatch(fetchAddProviderLanguages({ providerId, data })).then(() => {
            dispatch(fetchProviderLanguages(providerId));
          });
          setOpenPopup(!openPopup);
        }}
        customRender={RenderLanguagesAutoComplete}
        popupHeading="Add languages"
      />
    );
  };

  const RenderLanguages = () => {
    if (langData?.length < 1 && langError) return null;

    return (
      <div className="languagesWrapper">
        {langData?.map((item) => {
          return (
            <div className="g-col-6 languages-info" key={item.displayId}>
              {item.name}
              <div className="deleteBtnwithConfirm">
                {confirmDeleteMap[item.displayId] && (
                  <button
                    type="button"
                    className="btn border-0 canceldelete"
                    onClick={() => toggleConfirmDelete(item.displayId, false)}
                  >
                    CANCEL
                  </button>
                )}
                <button
                  type="button"
                  className={`btn ${
                    confirmDeleteMap[item.displayId]
                      ? "deleteConfirmation"
                      : "border-0"
                  }`}
                  onClick={() => {
                    if (confirmDeleteMap[item.displayId]) {
                      deleteAPiCall(item.displayId);
                    } else {
                      toggleConfirmDelete(item.displayId, true);
                    }
                  }}
                >
                  {confirmDeleteMap[item.displayId] ? "CONFIRM" : "DELETE"}
                </button>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  const RenderNoLangaugesInfo = () => {
    if (langData?.length > 0 || langError) return null;

    return (
      <div className="noDataInformationWrapper">
        No language data for this provider
      </div>
    );
  };

  return (
    <div>
    <div className="providerLanguagesSectionWrapper">
      <div className="overviewHeader">
        <h3 className="section-header top-thirty overview">
          Languages
          <a
            className="btn edit-button"
            onClick={() => {
              setOpenPopup(!openPopup);
            }}
          >
            +Add
          </a>
        </h3>
      </div>
      <div className="grid column-gap-2 newlanguagewrapper">
        {langError && (
          <div className="alert alert-danger" role="alert">
            {lngErrorMsg}
          </div>
        )}
      </div>
      {RenderLanguages()}
      {RenderNoLangaugesInfo()}
      {openPopup && RenderAddLanguagesPopup()}
    </div>
    </div>
  );
};

export default ProviderLanguagesSection;
